var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{ref:"ref-popover",staticClass:"ref-popover",class:[{ 'fade-in': _vm.visible }]},[_c('div',{class:['ref-popover-detail', _vm.effect]},[_c('div',{ref:"ref-popover-detail-body",staticClass:"ref-popover-detail-body"}),_c('div',{staticClass:"triangle"})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }